import { Typography } from '@mui/material'
import { isEmpty } from 'lodash'
import { useParams } from 'react-router-dom'
import Loading from '../../components/PageLoading'
import { BucketShareStatus } from '../../graphql/generated'
import GalleryLayout from './components/Layout'
import Toolbar from './components/Toolbar'
import InfiniteGrid from './components/grid/InfiniteGrid'
import useBucketMediaByShareId from './hooks/useBucketMediaByShareId'
import Carousel from './components/carousel'
import useBucketShareById from './hooks/useBucketShareById'

function Gallery() {
  const params = useParams<{ shareId: string; albumId: string }>()
  const albumId = params?.albumId
  const { items, loading, fetchMore, nextToken } = useBucketMediaByShareId()
  const { bucketShare, bucketShareLoading } = useBucketShareById()

  if (bucketShareLoading || loading) {
    return <Loading />
  }

  if (!bucketShare) {
    return null
  }

  if (bucketShare.shareStatus === BucketShareStatus.Expired) {
    return (
      <Typography align="center" variant="h5" sx={{ marginTop: 12 }}>
        This public share has expired
      </Typography>
    )
  }

  if (isEmpty(items)) {
    return (
      <Typography align="center" variant="h5" sx={{ marginTop: 12 }}>
        This {albumId ? 'album' : 'share'} has no media
      </Typography>
    )
  }

  return (
    <>
      <Toolbar bucketShare={bucketShare} />
      <Carousel items={items} fetchMore={fetchMore} hasMore={!!nextToken} />
      <InfiniteGrid items={items} fetchMore={fetchMore} hasMore={!!nextToken} />
    </>
  )
}

export default function ShareGallery() {
  return (
    <GalleryLayout>
      <Gallery />
    </GalleryLayout>
  )
}
